import { createContext } from "react";

export const ActivityIdContext = createContext<string | undefined>(undefined);
